<template>
    <div v-if="isBusy">
        <b-skeleton-img></b-skeleton-img>
    </div>
    <div v-else class="w-100 h-100">
        <apexchart :key="componentKey" :width="chartWidth" :height="height" type="pie" :options="pieChartOptions" :series="series"></apexchart>
    </div>
</template>
<style scoped>
</style>
<script>
import DataSource from '@/models/DataSource/DataSource';

export default {
    props: {
        id: {
            default: "app-pie-chart",
            type: String,
        },
        dataSourceId: {
            default: "",
            type: [Number, String],
        },
        dataSourceValue: {
            default: "",
            type: [Number, String],
        },
        chartLabel: {
            default: "",
            type: [Number, String],
        },
        chartValue: {
            default: "",
            type: [Number, String],
        },
        dataChart : 
        {
            default: function() {return [];},
            type: Array,
        },
        chartOptions : 
        {
            type: Object,
        },
        isParentBusy: {
            default: false,
            type: Boolean,
        },
        labelType: {
            default: "PERCENTAGE",
            type: String,
        },
        height: {
            default: 200,
            type: Number,
        }
    },
    data() {
        return {
            series : [],
            labels: [],
            title : '',
            isBusy : false,
            pieChartOptions: {
                chart: {
                    width: 380,
                    type: 'pie',
                    toolbar: {
                        show: false,
                    },
                },
                dataLabels: {
                    offset: 0,
                    minAngleToShowLabel: 10,
                    style: {
                        fontSize: '16px',
                        fontWeight: 'bold'
                    }, 
                }, 
                plotOptions: {
                    pie: {
                        startAngle: 0,
                        endAngle: 360,
                        expandOnClick: true,
                        offsetX: 0,
                        offsetY: 0,
                        customScale: 1,
                        dataLabels: {
                            offset: 0,
                            minAngleToShowLabel: 10,
                            style: {
                                fontSize: '16px',
                                fontWeight: 'bold'
                            }, 
                        }, 
                    },
                },
                legend: {
                    show: this.showLegend,
                    position: this.legendPosition,
                    labels: {
                        colors: ["#FFF"],
                        useSeriesColors: false
                    },
                },
                responsive: [{
                    breakpoint: 480,
                    
                    options: {
                        chart: {
                            width: 200,
                            height: 200,
                        },
                        legend: {
                            show: false,
                        }
                    }
                }]
            },
            chartWidth: this.width,
            componentKey: 0,
        }
    },
    mounted() {
        if (this.dataSourceId != null && this.dataSourceId != "" && this.dataSourceId != undefined) {
            this.getDataSource();
        } else if (this.dataChart != null) {
            this.setDataChart(this.dataChart);
        }
        this.chartWidth = "100%";
    },
    methods: {
        updateChart() {
            this.pieChartOptions.series = this.series;
            this.pieChartOptions.labels = this.labels;

            this.pieChartOptions.labels = this.labels;
            
            this.pieChartOptions.legend = {
                show: this.showLegend,
                position: this.legendPosition
            }
            
            if (this.labelType == "VALUE") {
                this.pieChartOptions.dataLabels = {
                    enabled: true,
                    formatter: function (val, opts) {
                        return opts.w.globals.series[opts.seriesIndex];
                    }
                }
            }

            this.componentKey += 1;
        },
        getDataSource() {
            this.isBusy = true;
			DataSource.getData(this, this.dataSourceId)
            .then(result => { 
                if (Array.isArray(result)) {
                    if (result.length > 0) {
                        const labels = result.map(data => data[this.chartLabel]);
                        const values = result.map(data =>parseFloat(data[this.chartValue]));
                        
                        this.series = values;
                        this.labels = labels;
                    }
                } 
                this.isBusy = false;
            })
            .catch(error => { 
                this.isBusy = false; 
            });
        },
        setDataChart(newValue) {
            if (newValue != null) {
                    if (Array.isArray(newValue)) {
                        if (newValue.length > 0) {
                            const labels = newValue.map(data => data[this.chartLabel]);
                            const values = newValue.map(data =>parseFloat(data[this.chartValue]));
                            
                            this.series = values;
                            this.labels = labels;
                        }
                    }
                }
        }
    },
    computed: {
        showLegend() {
            if (this.chartOptions.legend) {
                return true;
            }
            return false;
        },
        legendPosition() {
            if (this.chartOptions.legendPosition) {
                return this.chartOptions.legendPosition;
            }
            return 'bottom';
        }
    },
    watch: {
        width(newValue) {
            this.chartWidth = newValue;
        },
        series(newValue) {
            this.updateChart();
        },
        labels(newValue) {
            this.updateChart();
        },
        dataChart: {
            handler: function(newValue, oldVal) {
                this.setDataChart(newValue);
            },
            deep: true
        },
        isParentBusy(newValue) {
            this.isBusy = newValue;
        },
        chartOptions: {
            handler: function(newVal, oldVal) {
                this.updateChart();
            },
            deep: true
        },
    }
}
</script>